export const initialState = {
  viewAllModal : {value: false}
};
